/* @flow */

import type { $WidgetEnvConfiguration } from '../types/WidgetEnvConfiguration';
import Endpoints from 'CoreConstants/Endpoints';
import Environments from 'CoreConstants/Environments';
import HereMapsCredentials from 'CoreComponents/MapProviders/HereMaps/HereMapsCredentials';

const config: $WidgetEnvConfiguration = {
  env: Environments.ENV_TESTING,
  configurationServiceEndpointInternal: Endpoints.INTERNAL.DSW.CMS.UNIT_TESTING,
  configurationServiceEndpointExternal: Endpoints.EXTERNAL.CMS.UNIT_TESTING,
  dealerServiceEndpointInternal: Endpoints.INTERNAL.DSW.DMS.UNIT_TESTING,
  dealerServiceEndpointExternal: Endpoints.EXTERNAL.DMS.UNIT_TESTING,
  mapProviders: {
    hereMaps: {
      appId: HereMapsCredentials.DEV_APP_ID,
      appCode: HereMapsCredentials.DEV_APP_CODE,
      useCIT: true
    }
  }
};

export default config;
